import 'normalize.css/normalize.css';
import './index.less';
import '../_util/upgradeTip';



// WEBPACK FOOTER //
// ./components/style/index.tsx